<button class="button" (click)="togleMembratedLetterOverlay()">
  Cartas membretadas
</button>
<div class="overlay" *ngIf="membratedLetterOverlay">
  <div class="overlay__content overlay__content--list">
    <div class="table-header">
      <h2 class="title">
        <span (click)="togleMembratedLetterOverlay()">
          <app-arrow-back></app-arrow-back>
        </span>
        Cartas membretadas
      </h2>
      <button class="button button-create" (click)="togleCreateMembratedLetter()">
        Crear
      </button>
    </div>
    <p class="normalText">Toneladas disponibles: {{ tonnageAvailable | number : '1.3-3' }}</p>
    <app-table
      [table_config]="table_config"
      [array]="membratedLetterListByBatch"
      [loader]="loader"
      (onActualizarAbandono)="downloadPrintMembratedLetter($event, 'download')"
      (onEliminarAbandono)="downloadPrintMembratedLetter($event, 'print')"
      (onDescargarPedimento)="confirmDelete($event)"
    ></app-table>
  </div>
</div>
<div class="overlay" *ngIf="createMembratedLetterOverlay">
  <div class="overlay__content overlay__content--create">
    <div class="table-header no-margin">
      <h2 class="title">
        <span (click)="togleCreateMembratedLetter()">
          <app-arrow-back></app-arrow-back>
        </span>
        Crear
      </h2>
    </div>
    <p class="normalText">Toneladas disponibles: {{ tonnageAvailable | number : '1.3-3' }}</p>
    <form
      class="container-grid formCreateLetter"
      autocomplete="on"
      [formGroup]="tonnageForm"
      (ngSubmit)="confirmCreateMembratedLetter()"
    >
      <div>
        <label for="tonnage" class="form-label">Tonelaje*</label>
        <input
          type="number"
          id="tonnage"
          class="form-control"
          formControlName="tonnage"
        />
        <span
          class="form-text text-danger"
          *ngIf="
            tonnageForm.get('tonnage').hasError('required') &&
            tonnageForm.get('tonnage')!.touched
          "
        >
          Ingresa un tonelaje
        </span>
        <span
          class="form-text text-danger"
          *ngIf="tonnageForm.get('tonnage')?.hasError('pattern')"
        >
          Ingresa un tonelaje positivo y con máximo tres decimales
        </span>
      </div>
      <div class="grid-all container-button container-no-margin">
        <button type="button" class="btn-lote button-no-margin" (click)="togleCreateMembratedLetter()">
          Cancelar
        </button>
        <button type="submit" class="btn-lote ms-5 btn-size">Crear</button>
      </div>
    </form>
  </div>
</div>
<app-overlay
  *ngIf="loading"
></app-overlay>
<app-overlay
  *ngIf="overlayError"
  [reload]="true"
></app-overlay>
<app-overlay
  *ngIf="overlay"
  [icono]="icon"
  [mensaje]="message"
  [buttons]="buttons"
  (onDeleteLote)="createMembratedLetter($event)"
></app-overlay>
<app-overlay
  *ngIf="confirmDeleteOverlay"
  [mensaje]="messageDelete"
  buttons="true"
  (onDeleteLote)="deleteMembratedLetter($event)"
></app-overlay>
